<template>
  <div>
    <a-row justify="space-between" align="middle" class="mb-2">
      <a-col :span="8">
        <a-row type="flex" align="middle">
          <svg
            focusable="false"
            data-icon="arrow-left"
            width="1.3em"
            height="2em"
            fill="currentColor"
            aria-hidden="true"
            viewBox="64 64 896 896"
            style="cursor: pointer"
            @click="goBack"
          >
            <path
              d="M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
            ></path>
          </svg>
          <a-typography-title :level="4" class="ml-1" style="margin-bottom: 0">
            Datos colaborador
          </a-typography-title>
        </a-row>
      </a-col>
      <a-col>
        <a-button @click="openEditEmployeeModal">Editar info</a-button>
      </a-col>
    </a-row>
    <a-row class="mb-4">
      <a-col :span="24">
        <div>
          <a-card :body-style="'padding:0;'" :bordered="false">
            <a-descriptions class="" bordered>
              <a-descriptions-item label="RUT" :span="3">
                {{ rutToolBox.formatRut(employeeData?.rut) }}
              </a-descriptions-item>
              <a-descriptions-item label="Nombre completo" :span="3">
                {{ employeeData?.fullname }}
              </a-descriptions-item>
              <a-descriptions-item label="Grupo(s)" :span="3">
                {{ employeeData.groupCompanies?.map((g) => g.name).join(',') }}
              </a-descriptions-item>
              <a-descriptions-item label="Fecha de nacimiento" :span="3">
                {{
                  employeeData.birthdayDate
                    ? moment(employeeData?.birthdayDate, 'YYYY-MM-DD').format(
                        'DD/MM/YYYY'
                      )
                    : 'Sin información'
                }}
              </a-descriptions-item>
              <a-descriptions-item label="Correo" :span="3">
                {{ employeeData?.email }}
              </a-descriptions-item>
              <a-descriptions-item label="Estado" :span="3">
                <a-tag :color="getColorByState(employeeData?.status)">
                  {{ (getTagText(employeeData?.status) ?? '').toUpperCase() }}
                </a-tag>
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
          <a-row v-if="employeeData?.status === 'PENDING'" class="mt-3">
            <a-col :span="24">
              <a-button
                type="primary"
                class="ml-0"
                @click="openPendingTicketsModal"
              >
                Detalle
              </a-button>
              <a-typography-text type="primary" class="ml-2">
                Revisar detalle de tickets pendientes
              </a-typography-text>
            </a-col>
          </a-row>
        </div>
      </a-col>
    </a-row>
    <a-row justify="space-between" align="middle">
      <a-col :span="8">
        <a-space direction="vertical">
          <a-typography-title :level="4">Coberturas</a-typography-title>
        </a-space>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between" align="middle" class="mb-2">
      <a-col :span="12">
        <a-radio-group :value="typeSelection" @change="handleChange">
          <a-radio-button style="margin: 1px; z-index: 0" value="Vigente">
            Vigente
          </a-radio-button>
          <a-radio-button value="No vigente">No Vigente</a-radio-button>
        </a-radio-group>
      </a-col>
    </a-row>

    <profile-collaborator-table
      :columns="columns"
      title="Coberturas"
      :data="employeeCoverages"
      :type-selection="typeSelection"
      @patchedEmployecoverage="fetchCoverageEmployee"
    />

    <a-row justify="space-between" align="middle" class="mt-3">
      <a-col :span="8">
        <a-space direction="vertical">
          <a-typography-title :level="4">Cargas</a-typography-title>
        </a-space>
      </a-col>
    </a-row>
    <profile-collaborator-table
      :columns="columnsCoverage"
      title="Cargas"
      :data="cargas"
      @patchedEmployeeDependent="fetchEmployeeDependents"
    />
    <a-modal
      v-model:visible="showPendingTicketsModal"
      title="Tickets pendientes del colaborador"
      :footer="null"
      centered
      destroyOnClose
      width="650px"
    >
      <a-descriptions size="small" :column="1" class="mb-3 no-bg-descriptions">
        <a-descriptions-item label="Titular">
          {{ employeeData?.fullname }}
        </a-descriptions-item>
        <a-descriptions-item label="RUT">
          {{ rutToolBox.formatRut(employeeData?.rut) }}
        </a-descriptions-item>
      </a-descriptions>

      <a-table
        row-key="id"
        size="small"
        :columns="pendingTicketsColumns"
        :data-source="pendingTickets"
        :pagination="false"
        :scroll="{ y: 280 }"
      >
        <template #state="{ text }">
          <tags v-if="text" :stateId="text" />
          <span v-else>-</span>
        </template>

        <template #action="{ record }">
          <a
            :href="getTicketHref(record.raw)"
            class="ant-btn ant-btn-link ant-btn-sm"
            @click="($event) => goToTicket(record.raw, $event)"
          >
            Ver más
          </a>
        </template>
      </a-table>

      <div style="text-align: right; margin-top: 16px">
        <a-button @click="showPendingTicketsModal = false">Cerrar</a-button>
      </div>
    </a-modal>
    <edit-employee-info-modal
      ref="editEmployeeInfoModalRef"
      @saved="refreshEmployeeData"
    />
  </div>
</template>

<script>
import { computed, onBeforeMount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import {
  FETCH_EMPLOYEE,
  GET_FULL_NAME,
  GET_DEPENDENTS,
  FETCH_DEPENDENTS,
  FETCH_USER_BY_COMPANY,
  GET_USER_BY_COMPANY,
  GET_COVERAGE_EMPLOYEE,
  FETCH_COVERAGE_EMPLOYEE,
  GET_EMPLOYEE
} from '@/store/types';
import getTagColor from '@/utils/getTagColor';
import rutToolBox from '@/utils/Ruts';
import CollaboratorProfileTableCyC from '@/components/clients/stock/collaborator-profile-table-cyc.vue';
import EditEmployeeInfoModal from '@/components/clients/stock/modal-edit-employee-info.vue';
import getTagText from '@/utils/getTagText';
import notification from '@/utils/notifications';
import moment from 'moment';
import { useRouter } from 'vue-router';
import Tags from '@/components/tags.vue';

export default {
  name: 'ProfileCollaborator',
  emit: ['Poliza'],
  components: {
    'profile-collaborator-table': CollaboratorProfileTableCyC,
    'edit-employee-info-modal': EditEmployeeInfoModal,
    tags: Tags
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const typeSelection = ref('');
    const { id, colaborador } = route.params;

    const router = useRouter();
    const editEmployeeInfoModalRef = ref();

    const getTicketRoute = (ticket) => {
      const routeByType = {
        1: 'AltasDetalle',
        2: 'BajaDetail',
        3: 'DetalleModificaciones',
        4: 'TransferDetail',
        5: 'AltaCargasDetalle',
        6: 'BajaCargasDetalle'
      };

      const name = routeByType[ticket?.typeId];

      if (!name) {
        return null;
      }

      return {
        name,
        params: { id: ticket.id }
      };
    };

    const getTicketHref = (ticket) => {
      const ticketRoute = getTicketRoute(ticket);
      return ticketRoute ? router.resolve(ticketRoute).href : '#';
    };

    const goToTicket = (ticket, event) => {
      if (
        event?.defaultPrevented ||
        event?.button === 1 ||
        event?.metaKey ||
        event?.ctrlKey ||
        event?.shiftKey ||
        event?.altKey
      ) {
        return;
      }

      event?.preventDefault();

      const ticketRoute = getTicketRoute(ticket);

      if (!ticketRoute) {
        console.warn('No hay ruta para este typeId:', ticket?.typeId, ticket);
        return;
      }

      router.push(ticketRoute);
    };

    const employee = computed(() => store.getters[GET_EMPLOYEE]);

    const employeeData = computed(() => store.getters[GET_USER_BY_COMPANY]);
    const ticketTypeMap = {
      1: 'Alta',
      2: 'Baja',
      3: 'Modificacion',
      4: 'Traspaso',
      5: 'Altas de cargas',
      6: 'Baja de cargas'
    };

    const getTicketTypeName = (typeId) => {
      return ticketTypeMap[typeId] ?? 'Desconocido';
    };
    const getLastTicketState = (ticket) => {
      if (!ticket?.states?.length) return null;

      return [...ticket.states]
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
        .at(-1);
    };

    const belongsToCurrentCompany = (ticket) => {
      const currentCompanyId = String(id ?? '');

      const ticketCompanyIds = [
        ticket?.company?.id,
        ticket?.companyId,
        ticket?.company_id,
        ...(Array.isArray(ticket?.groupCompanies)
          ? ticket.groupCompanies.map((groupCompany) => groupCompany?.id)
          : [])
      ]
        .filter((value) => value !== undefined && value !== null)
        .map((value) => String(value));

      return ticketCompanyIds.includes(currentCompanyId);
    };

    const isTicketPending = (ticket) => {
      const lastState = getLastTicketState(ticket);
      return lastState && lastState.stateId !== 3 && lastState.stateId !== 4;
    };

    const pendingTickets = computed(() => {
      return (employee.value?.tickets ?? [])
        .filter(belongsToCurrentCompany)
        .filter(isTicketPending)
        .map((ticket) => {
          const lastState = getLastTicketState(ticket);
          return {
            id: ticket.id,
            type: getTicketTypeName(ticket.typeId),
            stateId: lastState?.stateId,
            raw: ticket
          };
        });
    });

    const showPendingTicketsModal = ref(false);

    const openPendingTicketsModal = (event) => {
      event?.target?.blur();
      showPendingTicketsModal.value = true;
    };

    const pendingTicketsColumns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        customRender: ({ text }) => `#${text}`
      },
      {
        title: 'Tipo',
        dataIndex: 'type',
        key: 'type'
      },
      {
        title: 'Estado',
        dataIndex: 'stateId',
        key: 'stateId',
        slots: { customRender: 'state' }
      },
      {
        title: 'Acción',
        key: 'action',
        slots: { customRender: 'action' }
      }
    ];

    const name = computed(() => store.getters[GET_FULL_NAME]);
    const employeeCoverages = computed(
      () => store.getters[GET_COVERAGE_EMPLOYEE]
    );
    const cargas = computed(() => store.getters[GET_DEPENDENTS]);

    // * Colores por estado
    const getColorByState = (value) => {
      return getTagColor(value);
    };

    const columns = [
      {
        title: 'Aseguradora',
        dataIndex: 'insuranceCompany.businessName',
        key: 'insuranceCompany.businessName'
      },
      {
        title: 'N° Póliza',
        dataIndex: 'policy.numberPolicy',
        key: 'policy.numberPolicy'
      },
      {
        title: 'Grupo',
        dataIndex: 'groupCompany.name',
        key: 'groupCompany.name'
      },
      {
        title: 'Cobertura',
        dataIndex: 'name',
        key: 'name'
      },
      {
        title: 'Vigencia',
        dataIndex: 'vigencia',
        key: 'vigencia'
      },
      {
        title: 'Acción',
        dataIndex: 'id',
        key: 'id',
        slots: {
          customRender: 'action'
        }
      }
    ];
    const columnsCoverage = [
      {
        title: 'Carga',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'RUT',
        dataIndex: 'rut',
        key: 'rut'
      },
      {
        title: 'Nombre completo',
        dataIndex: 'fullName',
        key: 'fullName'
      },
      {
        title: 'Fecha de nacimiento',
        dataIndex: 'birthdayDate',
        key: 'birthdayDate'
      },
      {
        title: 'Vigencia',
        dataIndex: 'vigencia',
        key: 'vigencia'
      },
      {
        title: 'Acción',
        dataIndex: 'id',
        key: 'id',
        width: '173px',
        slots: {
          customRender: 'action'
        }
      }
    ];
    const handleChange = async (val) => {
      typeSelection.value = val.target.value;
      if (
        typeSelection.value == 'Vigente' &&
        employeeCoverages.value.filter((f) => f.status == 'ACTIVE')
      ) {
        employeeCoverages.value.filter((f) => f.status == 'ACTIVE');
        return await store.dispatch(FETCH_COVERAGE_EMPLOYEE, {
          companyId: id,
          employeeId: colaborador,
          queryParam: '?status=ACTIVE'
        });
      } else if (
        typeSelection.value == 'No vigente' &&
        employeeCoverages.value.filter((f) => f.status == 'INACTIVE')
      ) {
        employeeCoverages.value.filter((f) => f.status == 'INACTIVE');
        return await store.dispatch(FETCH_COVERAGE_EMPLOYEE, {
          companyId: id,
          employeeId: colaborador,
          queryParam: '?status=INACTIVE'
        });
      }
    };

    const fetchCoverageEmployee = () => {
      store
        .dispatch(FETCH_COVERAGE_EMPLOYEE, {
          companyId: id,
          employeeId: colaborador,
          queryParam: '?status=ACTIVE'
        })
        .catch((err) => {
          notification('error', 'Error', err.response.data.message);
        });
    };

    const fetchEmployeeDependents = () => {
      store
        .dispatch(FETCH_DEPENDENTS, route.params.colaborador)
        .catch((err) => {
          notification('error', 'Error', err.response.data.message);
        });
    };

    const refreshEmployeeData = async () => {
      await store.dispatch(FETCH_EMPLOYEE, route.params.colaborador);
      await store.dispatch(FETCH_USER_BY_COMPANY, {
        company_id: route.params.id,
        employee_id: route.params.colaborador
      });
    };

    const openEditEmployeeModal = () => {
      editEmployeeInfoModalRef.value?.openModal(employeeData.value);
    };

    const goBack = () => {
      router.go(-1);
    };

    onBeforeMount(async () => {
      await refreshEmployeeData();
    });

    onMounted(() => {
      fetchCoverageEmployee();
      fetchEmployeeDependents();
      typeSelection.value = 'Vigente';
    });

    return {
      // current_tab,
      columnsCoverage,
      getColorByState,
      cargas,
      columns,
      name,
      employeeCoverages,
      employeeData,
      rutToolBox,
      getTagText,
      typeSelection,
      handleChange,
      fetchCoverageEmployee,
      fetchEmployeeDependents,
      showPendingTicketsModal,
      openPendingTicketsModal,
      pendingTickets,
      pendingTicketsColumns,
      getLastTicketState,
      getTicketTypeName,
      getTicketHref,
      goToTicket,
      employee,
      editEmployeeInfoModalRef,
      openEditEmployeeModal,
      goBack,
      refreshEmployeeData,
      moment
    };
  }
};
</script>

<style>
.no-bg-descriptions .ant-descriptions-item-label,
.no-bg-descriptions .ant-descriptions-item-content {
  background: transparent !important;
}
</style>
